import React, { useEffect, useState, useContext } from "react";
import { View, StyleSheet, Text, TouchableHighlight, ScrollView } from 'react-native';
import { ListItem } from "../components/lists";
import { MaterialCommunityIcons, FontAwesome5 } from "@expo/vector-icons";
import connectionConfig from "../config/settings";
//import { createStackNavigator } from "@react-navigation/stack";
import {  TouchableOpacity } from "react-native-gesture-handler";
//import useAuth from "../auth/useAuth";
import routes from "../navigation/routes";
import colors from "../config/colors";
import configurationPost from "../config/configurationPost";
//import Screen from "../components/Screen";
import SlideNavigator from "../navigation/SlideNavigator";
import dateNow from '../utility/dateNow';
import AuthContext from "../auth/context";

var arrayUserHistory = []

function UserFixoScreen({ navigation, route }) {

  var foundUserChecker = "off"

  //debugger
  useEffect(() => {
    //debugger
    arrayUserHistory = []
    navigation.addListener('focus', () => {
      getFollowedAndFollowers()
      getValidateHistorys()
      date = dateNow()
      //alert('MosaicOfPublications Screen was focused')
    })

    getFollowedAndFollowers()
    //getValidateHistorys()
  }, []);
  const { user, setUser } = useContext(AuthContext);
 // const { user } = useAuth();
  var date = ''
  const [followed, setFollowed] = useState(0)
  const [followers, setFollowers] = useState(0)
  const [ historyViseble, setHistoryViseble ] =  useState(true) // si hay historias de usuario las muestra 
  const  [ arrayUserHistoryHook, setArrayUserHistoryHook ] = useState([])
  var perfilUri = connectionConfig.imageUrl + '/PerfilDeUsuario/'
  var userId = JSON.parse(user).userId
  var userIdListing = JSON.parse(user).userId
  var userPhoto = JSON.parse(user).userPhoto
  var rolesNulos = (" ")
 //---------------------------------------------------
 //Valida  si el usario tine historias en el día
//---------------------------------------------------
  const getValidateHistorys = async () => {
    debugger
    var post_values = {
      userId: userId,
    }
    var configurationPost = {
      method: 'post',
      headers: {
        'Accept': 'application/json, text/plain, *.*',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(post_values)
    }
    await fetch(connectionConfig.apiUrl + '/SelectValidateHistorys/', configurationPost)
      .then(response => response.json())
      .then(response => {
        //  console.log('ejemplo de ->',response.data )
        if (response.data.length === 0) {
          setHistoryViseble(false)
        } else {
          //------------------------------------------------------
          //ejemplo de filter
              var result = response.data 
              var currentDay = new Date(date)
              var dayComparation
              var minusDate
             
              var fiterDateArray = result.filter(result =>  {
              
               dayComparation = new Date(result.createDateUserPublication)

               minusDate = (currentDay - dayComparation)
               console.log('minusDate ->', minusDate)
                if(minusDate < 86400000){
              
                 arrayUserHistory.push(
                      {
                      userPublicationId         : result.userPublicationId,
                      userPublicationPhoto      : result.userPublicationPhoto, 
                      createDateUserPublication : result.createDateUserPublication,
                      userId                    : result.userId,
                      totalLikes                : result.totalLikes,
                      totalComments             : result.totalComments
                      }  
                 )
                }
              })       
          }
         // setArrayUserHistoryHook(arrayUserHistory)
         console.log(' a de array->', arrayUserHistory.length)
         if(arrayUserHistory.length > 0){
      
          setHistoryViseble(true)       
         } else {
          setHistoryViseble(false)
         }
        //   console.log(' arrayUserHistory ->', arrayUserHistory)
        //   console.log('filterDateArray ->',fiterDateArray.length )

      })
      .catch(err => {
        console.log(' failed :( review internet service /SelectValidateHistorys/', err)
      })
  }

  //---------------------------------------------------
  //método para ir por el numero de segidore y seguidos
  //---------------------------------------------------
  const getFollowedAndFollowers = async () => {
    // debugger
    var post_values = {
      userId: userId
    }
    configurationPost.body = JSON.stringify(post_values)
    await fetch(connectionConfig.apiUrl + '/fixoUsers/SelectCountFollowers/', configurationPost)
      .then(response => response.json())
      .then(response => {
        setFollowers(response.data[0].total_siguen_a)
        //console.log('select regresa', response)
      })
      .catch(err => {
        console.log('Insert fixo failed :( review internet service', err)
      })
    //---------------------busca followers
    var post_values_ = {
      userId: userId
    }
    configurationPost.body = JSON.stringify(post_values_)
    await fetch(connectionConfig.apiUrl + '/fixoUsers/SelectCountFollowed/', configurationPost)
      .then(response => response.json())
      .then(response => {
        //debugger
        setFollowed(response.data[0].total_siguen_a)
        //console.log('select regresa', response)
      })
      .catch(err => {
        console.log('Insert fixo failed :( review internet service', err)
      })
  }
  //---------------------------------------------------------------
  //navega a este mismo screen UserFixoScreen para nulificar 
  // el onPress de la foto de perfil.
  //---------------------------------------------------------------  
  const onPressNada = () => {
    <TouchableHighlight disabled={true} />
  }

  //---------------------------------------------------------------
  //navega al screen FollowersScreen para mostrar lista de seguidores
  //---------------------------------------------------------------  
  const onPressFollowers = () => {

    navigation.navigate(routes.FOLLOWERS_SCREEN, { userId })
  }

  //---------------------------------------------------------------
  //navega al screen FollowedScreen para mostrar lista de seguidos
  //---------------------------------------------------------------  
  const onPressFollowed = () => {

    navigation.navigate(routes.FOLLOWED_SCREEN, { userIdListing })
  }



  return (
    <>
    <View style={styles.cont}>
    </View>
      {
       //......................................................
       //Sección que pinta el boton para las historias del perfil
       //......................................................
       historyViseble === true ? 
       <TouchableOpacity
       style={styles.buttonHistorys}
       onPress={() => {
       console.log('entre ', routes.USER_FIXO)
       var screen = 'UserFixoScreen'
       var userId = userId
       navigation.navigate(routes.DETAIL_HITORY, {screen, arrayUserHistory, userId})
       }} 
      >
      <FontAwesome5
              name="history"
              size={25}
              color={colors.black}
            // onPress={onPress}
              >
      </FontAwesome5>
      </TouchableOpacity> 
       :
       null
      }
      
      {
       //......................................................
       //Sección que pinta los segidores y la imagen de perfil
       //......................................................
      }
      <View style={styles.containerM} >
        <ListItem
          image={perfilUri + JSON.parse(user).userId + '_' + JSON.parse(user).userPhoto}
          //titleRol='User Rol'
          titleFollowers='Seguidores'
          subTitleFollowers={followers}
          onPress={onPressNada}
          onPress1={onPressFollowers}
          onPress2={onPressFollowed}
          titleFollowed='Seguidos'
          subTitleFollowed={followed}
          title={JSON.parse(user).userName}
          subTitle={rolesNulos}
        />
      </View>
      
      {
       //......................................................................
       //Sección que pinta el nombre de usuario  y el boton para editar perfil
       //......................................................................
      }
      <View style={styles.nameEditContainer}>
        <TouchableOpacity style={styles.button}
          onPress={() => {
            console.log('entre ', routes.USER_FIXO)
            navigation.navigate(routes.EDITAR_PERFIL)
          }} >
          <Text style={styles.text}>
            Editar
          </Text>
        </TouchableOpacity>
        
        <Text style={styles.textName} >{JSON.parse(user).userName}</Text>
      </View> 
    
      <View style={styles.al}>
      {
       //.............................
       //Sección que pinta el mosaico 
       //.............................
      }
      
      <SlideNavigator style={styles.al}
        navigation={navigation}
        userId={JSON.parse(user).userId}
        foundUserChecker={foundUserChecker}
      >
      </SlideNavigator>       
      
      
    </View>
    </>
  );
}

const styles = StyleSheet.create({
  cont: {
    backgroundColor:colors.blueFollow,
    width: '100%',
    //marginTop: '-15%', // Este era el mistario del margen inamovible, funcionó al ponerlo negativo.
   //height: 10,
 // flex:1
  },
  containerM: {
    //height: '11%'
    backgroundColor:'red'
  },
  containerS: {
    backgroundColor:colors.chakra0red,
    justifyContent: 'space-between',
    // alignItems:'center',
    width:'100%',
    //height:'80%',  
   flexDirection:'row',
    flex: 1,
  },
  nameEditContainer: {
    width: '80%',
    //height: '15%',
    flexDirection: 'row',
    alignItems: 'baseline',
    justifyContent: 'flex-start',
    marginLeft: '6%',
    //marginTop: '2%'
  },
  image: {
    width: 90,
    height: 90,
    borderRadius: 45,
    backgroundColor: 'red',
  },
  text: {
    color: colors.white,
    fontSize: 18,
    //textTransform: "uppercase",
    //fontWeight: "bold",
  },
  textName: {
    color: colors.dark,
    fontSize: 18,
    marginLeft: "8%",
  },
  button: {
    backgroundColor: colors.primary,
    borderRadius: 25,
    justifyContent: "center",
    alignItems: "center",
    padding: 2,
    // width: "100%",
    marginRight: "5%",
    //marginVertical: 10,
  },
  buttonHistorys:{
   // position:'absolute',
   // marginBottom:'-1%',
    marginLeft:'11%',
   width: 60,
   height: 30,
    //backgroundColor: colors.lemonGreen,
  },
  al:{
  width:500,
  height:550
  },
})

export default UserFixoScreen;